import Image from 'global/Image';
import {
  Header,
  HeaderDescription,
  HeaderSubtitle,
  HeaderTitle,
} from './styled';

const MulaiInvestasiHeader = () => (
  <Header>
    <HeaderDescription>
      <HeaderTitle>
        Daftar 100% Online
        <br />
        Tanpa Minimum Deposit
      </HeaderTitle>
      <HeaderSubtitle>
        Akun rekening kamu akan diproses secara digital tanpa perlu mengirim
        dokumen fisik.
      </HeaderSubtitle>
    </HeaderDescription>
    <Image src="/images/pro2-new.svg" />
  </Header>
);

export default MulaiInvestasiHeader;
